import {
  RequestAddAddressType,
  RequestEditAddressType,
} from 'b2b-apps/shop/myAccount/addresses/api/Address.types';
import {
  AddAddressAction,
  AddAddressCallbackType,
  AddressType,
  ClearAccountAddressAction,
  EditAddressAction,
  EditAddressCallbackType,
  FetchAddressAction,
  FetchAddressFulfilledAction,
  FetchAddressRejectedAction,
  RemoveAddressAction,
  RemoveAddressCallbackType,
} from 'b2b-common/core/account/api/Address.types';
import {
  ADD_ADDRESS,
  CLEAR_ACCOUNT_ADDRESS,
  EDIT_ADDRESS,
  FETCH_ADDRESS,
  FETCH_ADDRESS_FULFILLED,
  FETCH_ADDRESS_REJECTED,
  REMOVE_ADDRESS,
} from './actionTypes';

const fetchAddress = (code: string): FetchAddressAction => ({
  type: FETCH_ADDRESS,
  payload: {
    code,
  },
});

const fetchAddressFulfilled = (
  code: string,
  response: AddressType,
): FetchAddressFulfilledAction => ({
  type: FETCH_ADDRESS_FULFILLED,
  payload: {
    code,
    data: response,
  },
});

const fetchAddressRejected = (
  code: string,
  error: ErrorType,
): FetchAddressRejectedAction => ({
  type: FETCH_ADDRESS_REJECTED,
  payload: {
    code,
    error,
  },
});

const addAddress = (
  addressData: RequestAddAddressType,
  callback: AddAddressCallbackType,
): AddAddressAction => ({
  type: ADD_ADDRESS,
  payload: {
    addressData,
    callback,
  },
});

const editAddress = (
  code: string,
  addressData: RequestEditAddressType,
  callback: EditAddressCallbackType,
): EditAddressAction => ({
  type: EDIT_ADDRESS,
  payload: {
    code,
    addressData,
    callback,
  },
});

const removeAddress = (
  code: string,
  callback: RemoveAddressCallbackType,
): RemoveAddressAction => ({
  type: REMOVE_ADDRESS,
  payload: {
    code,
    callback,
  },
});

const clearAccountAddress = (): ClearAccountAddressAction => ({
  type: CLEAR_ACCOUNT_ADDRESS,
});

export {
  addAddress,
  clearAccountAddress,
  editAddress,
  fetchAddress,
  fetchAddressFulfilled,
  fetchAddressRejected,
  removeAddress,
};
